/* unplugin-vue-components disabled */import { render } from "./templateDemoEdit.vue?vue&type=template&id=3cfd2188&scoped=true"
import script from "./templateDemoEdit.vue?vue&type=script&lang=js"
export * from "./templateDemoEdit.vue?vue&type=script&lang=js"

import "./templateDemoEdit.vue?vue&type=style&index=0&id=3cfd2188&scoped=true&lang=css"

import exportComponent from "/home/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3cfd2188"]])

export default __exports__